function PadZero(format, num){
  if((format + "").length === 1){
    if(num < 10){
      num = "0" + num;
    }
  }else if((format + "").length === 2){
    if(num < 10){
      num = "00" + num;
    }else if(num < 100){
      num = "0" + num;
    }
  }
  return num;
}

export default PadZero;